const paragraphSerializer = ((_, children) => {
  return `<p>${children}</p>`;
});

export { paragraphSerializer };
//# sourceMappingURL=serializer.js.map
